export const PACKAGE_NAME = '@ori/i18n';
//# sourceMappingURL=constants.js.map